<template>
  <div class="data-management well-page">
    <div class="well-top-wrap">
      <!-- Tabs -->
      <v-tabs v-model="activeTab" color="primary" class="qa-tabs">
        <v-tab value="wells">Wells</v-tab>
        <!-- <v-tab value="sourceFiles">Source Files</v-tab> -->
      </v-tabs>
      
    </div>

    <TabularLoaders v-if="showLoader" />
    
    <!-- Wells Tab Content -->
    <v-table v-if="activeTab === 'wells' && wells.length > 0" class="well-table sample-table well-table-data">
      <thead>
        <tr class="main-header">
          <th class="search-dropdown-menu" :style="{ backgroundColor: searchDropdowns.wells ? 'black !important' : 'transparent' }">
            <v-menu v-model="searchDropdowns.wells" :close-on-content-click="false" transition="scale-transition">
              <template v-slot:activator="{ props }">
                <span v-bind="props" :id="`menu-activator-wells`"></span>
              </template>
              <v-list style="min-width: 182px; max-width: 200px; border-radius: 8px !important; height: 244px !important; padding: 8px; max-height: 244px; overflow-y: auto; position: absolute; top: 3.25em; left: -0.5em; transform: translateY(-1.25em);">
                <!-- Search Field -->
                <v-text-field variant="solo" class="search-table" v-model="searchQuery.wells" :label="`Search wells`" single-line hide-details>
                  <template v-slot:prepend>
                    <v-img :src="magnify_black" class="ml-2" width="24" height="24"></v-img>
                  </template>
                </v-text-field>
                <!-- Filter Options -->
                <v-list-item v-for="option in getFilteredOptions('wells')" :key="option" class="list-items" style="margin: 0 !important; padding: 4px 8px !important; min-height: 32px !important;">
                  <div class="data-list-content">
                    <input type="checkbox" :checked="isOptionSelected('wells', option)" @change="toggleSelection('wells', option)" class="custom-checkbox" />
                    <span class="option-text">{{ option }}</span>
                  </div>
                </v-list-item>
                <!-- No Data Found -->
                <v-list-item v-if="getFilteredOptions('wells').length === 0" disabled>
                  <v-list-item-title style="font-size: 13px;">No data found</v-list-item-title>
                </v-list-item>
                <!-- Clear Filters -->
                <v-list-item v-if="getSelectedOptions('wells').length > 0" @click="clearColumnFilters('wells')" style="margin: 0 !important; padding: 4px 8px !important; min-height: 32px !important;">
                  <v-list-item-title style="font-size: 13px; color: #1976d2;">Clear Filters ({{ getSelectedOptions('wells').length }})</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
            <div class="sort-icon-title d-flex align-center" style="gap: 10px; width: 100%; justify-content: space-between;">
              <div class="sort-icons-with-text d-flex align-center" style="gap: 10px;">
                <div class="sort-icons">
                  <div class="img-div">
                    <img :src="sort_up" alt="sort-up" class="cursor-pointer" @click="sortColumn('name', 'asc')" />
                  </div>
                  <div class="img-div">
                    <img :src="sort_down" alt="sort-down" class="cursor-pointer" @click="sortColumn('name', 'desc')" />
                  </div>
                </div>
                <span>Well Number</span>
              </div>
              <div class="close-icon" v-if="searchDropdowns.wells" @click="searchDropdowns.wells = false">
                <v-img :src="close_icon" alt="close-icon"></v-img>
              </div>
              <div v-else class="search-icon" @click="showSearchDropdown('wells')" :id="`menu-activator-wells`">
                <v-img :src="magnify" alt="search-icon" width="20" height="20"></v-img>
              </div>
            </div>
          </th>
          <th class="text-center search-dropdown-menu" :style="{ backgroundColor: searchDropdowns.samples ? 'black !important' : 'transparent' }">
            <v-menu v-model="searchDropdowns.samples" :close-on-content-click="false" transition="scale-transition">
              <template v-slot:activator="{ props }">
                <span v-bind="props" :id="`menu-activator-samples`"></span>
              </template>
              <v-list style="min-width: 182px; max-width: 200px; border-radius: 8px !important; height: 244px !important; padding: 8px; max-height: 244px; overflow-y: auto; position: absolute; top: 3.25em; left: -0.5em; transform: translateY(-1.25em);">
                <!-- Search Field -->
                <v-text-field variant="solo" class="search-table" v-model="searchQuery.samples" :label="`Search samples`" single-line hide-details>
                  <template v-slot:prepend>
                    <v-img :src="magnify_black" class="ml-2" width="24" height="24"></v-img>
                  </template>
                </v-text-field>
                <!-- Filter Options -->
                <v-list-item v-for="option in getFilteredOptions('samples')" :key="option" class="list-items" style="margin: 0 !important; padding: 4px 8px !important; min-height: 32px !important;">
                  <div class="data-list-content">
                    <input type="checkbox" :checked="isOptionSelected('samples', option)" @change="toggleSelection('samples', option)" class="custom-checkbox" />
                    <span class="option-text">{{ option }}</span>
                  </div>
                </v-list-item>
                <!-- No Data Found -->
                <v-list-item v-if="getFilteredOptions('samples').length === 0" disabled>
                  <v-list-item-title style="font-size: 13px;">No data found</v-list-item-title>
                </v-list-item>
                <!-- Clear Filters -->
                <v-list-item v-if="getSelectedOptions('samples').length > 0" @click="clearColumnFilters('samples')" style="margin: 0 !important; padding: 4px 8px !important; min-height: 32px !important;">
                  <v-list-item-title style="font-size: 13px; color: #1976d2;">Clear Filters ({{ getSelectedOptions('samples').length }})</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
            <div class="sort-icon-title d-flex align-center" style="gap: 10px; width: 100%; justify-content: space-between;">
              <div class="sort-icons-with-text d-flex align-center" style="gap: 10px;">
                <div class="sort-icons">
                  <div class="img-div">
                    <img :src="sort_up" alt="sort-up" class="cursor-pointer" @click="sortColumn('samples', 'asc')" />
                  </div>
                  <div class="img-div">
                    <img :src="sort_down" alt="sort-down" class="cursor-pointer" @click="sortColumn('samples', 'desc')" />
                  </div>
                </div>
                <span>No. Samples</span>
              </div>
              <div class="close-icon" v-if="searchDropdowns.samples" @click="searchDropdowns.samples = false">
                <v-img :src="close_icon" alt="close-icon"></v-img>
              </div>
              <div v-else class="search-icon" @click="showSearchDropdown('samples')" :id="`menu-activator-samples`">
                <v-img :src="magnify" alt="search-icon" width="20" height="20"></v-img>
              </div>
            </div>
          </th>
        </tr>
      </thead>
      <tbody class="well-table-content">
        <template v-for="(well, index) in filteredWells" :key="index">
          <tr>
            <td @click="navigateToDetailView('wells', well.name)"> <span class="cursor-pointer clickable-cell well-cell no-bg">{{well.name}}</span></td>
            <td class="text-center">{{ well.counts.samples }}</td>
          </tr>
        </template>
      </tbody>
    </v-table>

    <!-- Source Files Tab Content -->
    <v-table v-if="activeTab === 'sourceFiles' && sourceFiles.length > 0" class="well-table sample-table well-table-data">
      <thead>
        <tr class="main-header">
          <th class="search-dropdown-menu" :style="{ backgroundColor: searchDropdowns.fileName ? 'black !important' : 'transparent' }">
            <v-menu v-model="searchDropdowns.fileName" :close-on-content-click="false" transition="scale-transition">
              <template v-slot:activator="{ props }">
                <span v-bind="props" :id="`menu-activator-fileName`"></span>
              </template>
              <v-list style="min-width: 182px; max-width: 200px; border-radius: 8px !important; height: 244px !important; padding: 8px; max-height: 244px; overflow-y: auto; position: absolute; top: 3.25em; left: -0.5em; transform: translateY(-1.25em);">
                <!-- Search Field -->
                <v-text-field variant="solo" class="search-table" v-model="searchQuery.fileName" :label="`Search fileName`" single-line hide-details>
                  <template v-slot:prepend>
                    <v-img :src="magnify_black" class="ml-2" width="24" height="24"></v-img>
                  </template>
                </v-text-field>
                <!-- Filter Options -->
                <v-list-item v-for="option in getFilteredOptions('fileName')" :key="option" class="list-items" style="margin: 0 !important; padding: 4px 8px !important; min-height: 32px !important;">
                  <div class="data-list-content">
                    <input type="checkbox" :checked="isOptionSelected('fileName', option)" @change="toggleSelection('fileName', option)" class="custom-checkbox" />
                    <span class="option-text">{{ option }}</span>
                  </div>
                </v-list-item>
                <!-- No Data Found -->
                <v-list-item v-if="getFilteredOptions('fileName').length === 0" disabled>
                  <v-list-item-title style="font-size: 13px;">No data found</v-list-item-title>
                </v-list-item>
                <!-- Clear Filters -->
                <v-list-item v-if="getSelectedOptions('fileName').length > 0" @click="clearColumnFilters('fileName')" style="margin: 0 !important; padding: 4px 8px !important; min-height: 32px !important;">
                  <v-list-item-title style="font-size: 13px; color: #1976d2;">Clear Filters ({{ getSelectedOptions('fileName').length }})</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
            <div class="sort-icon-title d-flex align-center" style="gap: 10px; width: 100%; justify-content: space-between;">
              <div class="sort-icons-with-text d-flex align-center" style="gap: 10px;">
                <div class="sort-icons">
                  <div class="img-div">
                    <img :src="sort_up" alt="sort-up" class="cursor-pointer" @click="sortColumn('fileName', 'asc')" />
                  </div>
                  <div class="img-div">
                    <img :src="sort_down" alt="sort-down" class="cursor-pointer" @click="sortColumn('fileName', 'desc')" />
                  </div>
                </div>
                <span>Source File Name</span>
              </div>
              <div class="close-icon" v-if="searchDropdowns.fileName" @click="searchDropdowns.fileName = false">
                <v-img :src="close_icon" alt="close-icon"></v-img>
              </div>
              <div v-else class="search-icon" @click="showSearchDropdown('fileName')" :id="`menu-activator-fileName`">
                <v-img :src="magnify" alt="search-icon" width="20" height="20"></v-img>
              </div>
            </div>
          </th>
          <th class="text-center search-dropdown-menu" :style="{ backgroundColor: searchDropdowns.fileType ? 'black !important' : 'transparent' }">
            <v-menu v-model="searchDropdowns.fileType" :close-on-content-click="false" transition="scale-transition">
              <template v-slot:activator="{ props }">
                <span v-bind="props" :id="`menu-activator-fileType`"></span>
              </template>
              <v-list style="min-width: 182px; max-width: 200px; border-radius: 8px !important; height: 244px !important; padding: 8px; max-height: 244px; overflow-y: auto; position: absolute; top: 3.25em; left: -0.5em; transform: translateY(-1.25em);">
                <!-- Search Field -->
                <v-text-field variant="solo" class="search-table" v-model="searchQuery.fileType" :label="`Search fileType`" single-line hide-details>
                  <template v-slot:prepend>
                    <v-img :src="magnify_black" class="ml-2" width="24" height="24"></v-img>
                  </template>
                </v-text-field>
                <!-- Filter Options -->
                <v-list-item v-for="option in getFilteredOptions('fileType')" :key="option" class="list-items" style="margin: 0 !important; padding: 4px 8px !important; min-height: 32px !important;">
                  <div class="data-list-content">
                    <input type="checkbox" :checked="isOptionSelected('fileType', option)" @change="toggleSelection('fileType', option)" class="custom-checkbox" />
                    <span class="option-text">{{ option }}</span>
                  </div>
                </v-list-item>
                <!-- No Data Found -->
                <v-list-item v-if="getFilteredOptions('fileType').length === 0" disabled>
                  <v-list-item-title style="font-size: 13px;">No data found</v-list-item-title>
                </v-list-item>
                <!-- Clear Filters -->
                <v-list-item v-if="getSelectedOptions('fileType').length > 0" @click="clearColumnFilters('fileType')" style="margin: 0 !important; padding: 4px 8px !important; min-height: 32px !important;">
                  <v-list-item-title style="font-size: 13px; color: #1976d2;">Clear Filters ({{ getSelectedOptions('fileType').length }})</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
            <div class="sort-icon-title d-flex align-center" style="gap: 10px; width: 100%; justify-content: space-between;">
              <div class="sort-icons-with-text d-flex align-center" style="gap: 10px;">
                <div class="sort-icons">
                  <div class="img-div">
                    <img :src="sort_up" alt="sort-up" class="cursor-pointer" @click="sortColumn('fileType', 'asc')" />
                  </div>
                  <div class="img-div">
                    <img :src="sort_down" alt="sort-down" class="cursor-pointer" @click="sortColumn('fileType', 'desc')" />
                  </div>
                </div>
                <span>File Type</span>
              </div>
              <div class="close-icon" v-if="searchDropdowns.fileType" @click="searchDropdowns.fileType = false">
                <v-img :src="close_icon" alt="close-icon"></v-img>
              </div>
              <div v-else class="search-icon" @click="showSearchDropdown('fileType')" :id="`menu-activator-fileType`">
                <v-img :src="magnify" alt="search-icon" width="20" height="20"></v-img>
              </div>
            </div>
          </th>
          <th class="text-center search-dropdown-menu" :style="{ backgroundColor: searchDropdowns.qaqcStatus ? 'black !important' : 'transparent' }">
            <v-menu v-model="searchDropdowns.qaqcStatus" :close-on-content-click="false" transition="scale-transition">
              <template v-slot:activator="{ props }">
                <span v-bind="props" :id="`menu-activator-qaqcStatus`"></span>
              </template>
              <v-list style="min-width: 182px; max-width: 200px; border-radius: 8px !important; height: 244px !important; padding: 8px; max-height: 244px; overflow-y: auto; position: absolute; top: 3.25em; left: -0.5em; transform: translateY(-1.25em);">
                <!-- Search Field -->
                <v-text-field variant="solo" class="search-table" v-model="searchQuery.qaqcStatus" :label="`Search qaqcStatus`" single-line hide-details>
                  <template v-slot:prepend>
                    <v-img :src="magnify_black" class="ml-2" width="24" height="24"></v-img>
                  </template>
                </v-text-field>
                <!-- Filter Options -->
                <v-list-item v-for="option in getFilteredOptions('qaqcStatus')" :key="option" class="list-items" style="margin: 0 !important; padding: 4px 8px !important; min-height: 32px !important;">
                  <div class="data-list-content">
                    <input type="checkbox" :checked="isOptionSelected('qaqcStatus', option)" @change="toggleSelection('qaqcStatus', option)" class="custom-checkbox" />
                    <span class="option-text">{{ option }}</span>
                  </div>
                </v-list-item>
                <!-- No Data Found -->
                <v-list-item v-if="getFilteredOptions('qaqcStatus').length === 0" disabled>
                  <v-list-item-title style="font-size: 13px;">No data found</v-list-item-title>
                </v-list-item>
                <!-- Clear Filters -->
                <v-list-item v-if="getSelectedOptions('qaqcStatus').length > 0" @click="clearColumnFilters('qaqcStatus')" style="margin: 0 !important; padding: 4px 8px !important; min-height: 32px !important;">
                  <v-list-item-title style="font-size: 13px; color: #1976d2;">Clear Filters ({{ getSelectedOptions('qaqcStatus').length }})</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
            <div class="sort-icon-title d-flex align-center" style="gap: 10px; width: 100%; justify-content: space-between;">
              <div class="sort-icons-with-text d-flex align-center" style="gap: 10px;">
                <div class="sort-icons">
                  <div class="img-div">
                    <img :src="sort_up" alt="sort-up" class="cursor-pointer" @click="sortColumn('qaqcStatus', 'asc')" />
                  </div>
                  <div class="img-div">
                    <img :src="sort_down" alt="sort-down" class="cursor-pointer" @click="sortColumn('qaqcStatus', 'desc')" />
                  </div>
                </div>
                <span>QA/QC Status</span>
              </div>
              <div class="close-icon" v-if="searchDropdowns.qaqcStatus" @click="searchDropdowns.qaqcStatus = false">
                <v-img :src="close_icon" alt="close-icon"></v-img>
              </div>
              <div v-else class="search-icon" @click="showSearchDropdown('qaqcStatus')" :id="`menu-activator-qaqcStatus`">
                <v-img :src="magnify" alt="search-icon" width="20" height="20"></v-img>
              </div>
            </div>
          </th>
        </tr>
      </thead>
      <tbody class="well-table-content">
        <template v-for="(file, index) in filteredSourceFiles" :key="index">
          <tr>
            <td @click="navigateToDetailView('sourceFiles', file.name)"> <span class="cursor-pointer clickable-cell well-cell no-bg">{{file.name}}</span></td>
           
            <td class="text-center">
              <v-chip :color="getFileTypeColor(file.type)" size="small">
                {{ file.type }}
              </v-chip>
            </td>
            <td class="text-center">{{ formatDate(file.uploadDate) }}</td>

          </tr>
        </template>
      </tbody>
    </v-table>


    <!-- No Source Files Message -->
    <div v-if="activeTab === 'sourceFiles' && sourceFiles.length === 0 && !showLoader && timeoutMessage === ''" class="no-asset-div">
      <div class="text-center">
        <v-icon color="grey" size="large" class="mb-2">mdi-file-document-outline</v-icon>
        <h4>No source files found</h4>
        <p>There are no source files available for QA/QC review at this time.</p>
      </div>
    </div>

    <div v-else-if="timeoutMessage !== ''" class="no-asset-div timeout">
      <div class="text-center">
        <v-icon color="warning" size="large" class="mb-2">mdi-alert-circle</v-icon>
        <p>{{ timeoutMessage }}</p>
        <v-btn color="primary" @click="fetchData()" prepend-icon="mdi-reload">
          Retry
        </v-btn>
      </div>
    </div>

    <div v-else-if="wells.length === 0 && !showLoader && timeoutMessage === ''" class="no-asset-div">
      <div class="text-center">
        <v-icon color="grey" size="large" class="mb-2">mdi-well-off</v-icon>
        <h4>No wells found</h4>
        <p>There are no wells available for QA/QC review at this time.</p>
      </div>
    </div>

    <!-- QA/QC Review Modal -->
    <v-dialog v-model="showQAQCModal" max-width="600">
      <v-card>
        <v-card-title class="d-flex justify-space-between align-center">
          <span>QA/QC Review - {{ selectedSample?.fluidSampleID }}</span>
          <v-btn icon="mdi-close" variant="text" @click="showQAQCModal = false"></v-btn>
        </v-card-title>
        <v-card-text>
          <div v-if="selectedSample" class="sample-review-content">
            <div class="sample-info-section">
              <h6>Sample Information</h6>
              <div class="info-grid">
                <div class="info-item">
                  <strong>Sample ID:</strong> {{ selectedSample.fluidSampleID }}
                </div>
                <div class="info-item">
                  <strong>Sample Type:</strong> {{ selectedSample.sampleType }}
                </div>
                <div class="info-item">
                  <strong>Well:</strong> {{ selectedSample.wellName }}
                </div>
              </div>
            </div>
            
            <v-divider class="my-4"></v-divider>
            
            <div class="qa-status-section">
              <h6>QA/QC Status</h6>
              <v-select
                v-model="selectedSample.qaqcStatus"
                :items="qaqcStatusOptions"
                label="Select Status"
                variant="outlined"
                density="compact"
              ></v-select>
              
              <v-textarea
                v-model="selectedSample.qaqcNotes"
                label="QA/QC Notes"
                variant="outlined"
                rows="3"
                placeholder="Enter any notes or observations..."
              ></v-textarea>
            </div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn variant="outlined" @click="showQAQCModal = false">Cancel</v-btn>
          <v-btn color="primary" @click="saveQAQCReview">Save Review</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Source File QA/QC Review Modal -->
    <v-dialog v-model="showSourceFileQAQCModal" max-width="600">
      <v-card>
        <v-card-title class="d-flex justify-space-between align-center">
          <span>Source File QA/QC Review - {{ selectedSourceFile?.name }}</span>
          <v-btn icon="mdi-close" variant="text" @click="showSourceFileQAQCModal = false"></v-btn>
        </v-card-title>
        <v-card-text>
          <div v-if="selectedSourceFile" class="sample-review-content">
            <div class="sample-info-section">
              <h6>File Information</h6>
              <div class="info-grid">
                <div class="info-item">
                  <strong>File Name:</strong> {{ selectedSourceFile.name }}
                </div>
                <div class="info-item">
                  <strong>File Type:</strong> {{ selectedSourceFile.type }}
                </div>
                <div class="info-item">
                  <strong>Upload Date:</strong> {{ formatDate(selectedSourceFile.uploadDate) }}
                </div>
              </div>
            </div>
            
            <v-divider class="my-4"></v-divider>
            
            <div class="qa-status-section">
              <h6>QA/QC Status</h6>
              <v-select
                v-model="selectedSourceFile.qaqcStatus"
                :items="qaqcStatusOptions"
                label="Select Status"
                variant="outlined"
                density="compact"
              ></v-select>
              
              <v-textarea
                v-model="selectedSourceFile.qaqcNotes"
                label="QA/QC Notes"
                variant="outlined"
                rows="3"
                placeholder="Enter any notes or observations..."
              ></v-textarea>
            </div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn variant="outlined" @click="showSourceFileQAQCModal = false">Cancel</v-btn>
          <v-btn color="primary" @click="saveSourceFileQAQCReview">Save Review</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import api from "../../axiosInterceptor";
import TabularLoaders from "../../components/layout/Loaders/TabularLoaders.vue";

export default {
  name: "QAQCIndex",
  components: {
    TabularLoaders,
  },
  data() {
    return {
      activeTab: 'wells', // Default to wells tab
      wells: [],
      sourceFiles: [],
      tenantId: localStorage.getItem("tenantId"),
      showLoader: false,
      timeoutMessage: "",
      showQAQCModal: false,
      showSourceFileQAQCModal: false,
      selectedSample: null,
      selectedSourceFile: null,
      searchableColumns: [
        'wells', 'samples', 'fileName', 'fileType', 'qaqcStatus'
      ],
      searchDropdowns: {
        wells: false,
        samples: false,
        fileName: false,
        fileType: false,
        qaqcStatus: false
      },
      searchQuery: {
        wells: '',
        samples: '',
        fileName: '',
        fileType: '',
        qaqcStatus: ''
      },
      selectedFilters: {
        wells: [],
        samples: [],
        fileName: [],
        fileType: [],
        qaqcStatus: []
      },
      currentSortColumn: '',
      sortDirection: 'asc',
      qaqcStatusOptions: [
        'Pending Review',
        'Under Review',
        'Approved',
        'Rejected',
        'Needs Correction',
        'Completed'
      ],
      // Image imports for icons
      magnify: require("../../assets/Images/MagnifyingGlass.png"),
      magnify_black: require("../../assets/Images/magnify-black.png"),
      sort_up: require("../../assets/Svg/Table/up.svg"),
      sort_down: require("../../assets/Svg/Table/down.svg"),
      close_icon: require("../../assets/Images/close-circle.png")
    };
  },
  computed: {
    totalSamples() {
      return this.wells.reduce((total, well) => total + well.counts.samples, 0);
    },
    filteredWells() {
      let filtered = this.wells;
      
      // Apply column filters
      if (this.selectedFilters.wells.length > 0) {
        filtered = filtered.filter(well => 
          this.selectedFilters.wells.includes(well.name)
        );
      }
      
      if (this.selectedFilters.samples.length > 0) {
        filtered = filtered.filter(well => 
          this.selectedFilters.samples.includes(well.counts.samples.toString())
        );
      }
      
      // Apply sorting
      if (this.currentSortColumn) {
        filtered = filtered.sort((a, b) => {
          let aValue, bValue;
          
          if (this.currentSortColumn === 'name') {
            aValue = a.name;
            bValue = b.name;
          } else if (this.currentSortColumn === 'samples') {
            aValue = a.counts.samples;
            bValue = b.counts.samples;
          }
          
          if (this.sortDirection === 'asc') {
            return aValue > bValue ? 1 : -1;
          } else {
            return aValue < bValue ? 1 : -1;
          }
        });
      }
      
      return filtered;
    },
    filteredSourceFiles() {
      let filtered = this.sourceFiles;
      
      // Apply column filters
      if (this.selectedFilters.fileName.length > 0) {
        filtered = filtered.filter(file => 
          this.selectedFilters.fileName.includes(file.name)
        );
      }
      
      if (this.selectedFilters.fileType.length > 0) {
        filtered = filtered.filter(file => 
          this.selectedFilters.fileType.includes(file.type)
        );
      }
      
      if (this.selectedFilters.qaqcStatus.length > 0) {
        filtered = filtered.filter(file => 
          this.selectedFilters.qaqcStatus.includes(file.qaqcStatus)
        );
      }
      
      // Apply sorting
      if (this.currentSortColumn) {
        filtered = filtered.sort((a, b) => {
          let aValue, bValue;
          
          if (this.currentSortColumn === 'fileName') {
            aValue = a.name;
            bValue = b.name;
          } else if (this.currentSortColumn === 'fileType') {
            aValue = a.type;
            bValue = b.type;
          } else if (this.currentSortColumn === 'qaqcStatus') {
            aValue = a.qaqcStatus;
            bValue = b.qaqcStatus;
          }
          
          if (this.sortDirection === 'asc') {
            return aValue > bValue ? 1 : -1;
          } else {
            return aValue < bValue ? 1 : -1;
          }
        });
      }
      
      return filtered;
    }
  },
  watch: {
  },
  methods: {
    showSearchDropdown(column) {
      this.searchDropdowns[column] = !this.searchDropdowns[column];
    },
    getItemValue(item, column) {
      const columnMapping = {
        'wells': 'name',
        'samples': 'counts.samples',
        'fileName': 'name',
        'fileType': 'type',
        'qaqcStatus': 'qaqcStatus'
      };
      
      const key = columnMapping[column];
      if (key === 'counts.samples') {
        return item.counts.samples.toString();
      }
      return item[key] || '';
    },
    getFilteredOptions(column) {
      let allValues = [];
      
      if (column === 'wells' || column === 'samples') {
        allValues = this.wells.map(item => this.getItemValue(item, column));
      } else {
        allValues = this.sourceFiles.map(item => this.getItemValue(item, column));
      }
      
      const uniqueValues = [...new Set(allValues)].filter(value => value !== '');
      
      const query = this.searchQuery[column]?.toLowerCase() || '';
      return uniqueValues.filter(value => 
        value.toLowerCase().includes(query)
      );
    },
    isOptionSelected(column, option) {
      return this.selectedFilters[column].includes(option);
    },
    toggleSelection(column, option) {
      const index = this.selectedFilters[column].indexOf(option);
      if (index > -1) {
        this.selectedFilters[column].splice(index, 1);
      } else {
        this.selectedFilters[column].push(option);
      }
    },
    getSelectedOptions(column) {
      return this.selectedFilters[column];
    },
    clearColumnFilters(column) {
      this.selectedFilters[column] = [];
      this.searchQuery[column] = '';
    },
    sortColumn(column, direction) {
      this.currentSortColumn = column;
      this.sortDirection = direction;
    },
    fetchData() {
      this.showLoader = true;
      this.timeoutMessage = "";
      
      // For QA/QC, we'll fetch all wells without field restriction
      api
        .get(`public/api/locations/wells`)
        .then((response) => {
          if (response && response.data && (response.data.statusCode === 200 || response.data.statusCode === 201)) {
            this.wells = response.data.data.locations
              .sort((a, b) => parseInt(a.name.split("-")[1]) - parseInt(b.name.split("-")[1]))
              .map((well) => {
                return {
                  ...well,
                  expanded: false, // Set expanded to false by default (collapsed)
                  qaqcStatus: this.getRandomQAQCStatus(), // Mock QA/QC status for demo
                  lastUpdated: new Date(Date.now() - Math.random() * 30 * 24 * 60 * 60 * 1000), // Mock last updated
                  data: this.generateMockSamples(well) // Mock sample data
                };
              });
            
            // Generate mock source files data
            this.generateMockSourceFiles();
          }
          else if (response && response.data && response.data.message) {
            this.timeoutMessage = response.data.message;
          }
          else {
            this.timeoutMessage = "Error in fetching wells";
          }
        })
        .catch((error) => {
          this.timeoutMessage = error.message || "Error fetching wells data";
        })
        .finally(() => {
          this.showLoader = false;
        });
    },
    generateMockSamples(well) {
      // Generate mock sample data for demonstration
      const sampleTypes = ['Oil', 'Gas', 'Water', 'Condensate'];
      const qaqcStatuses = ['Pending Review', 'Under Review', 'Approved', 'Rejected', 'Needs Correction'];
      
      const sampleCount = well.counts.samples;
      const samples = [];
      
      for (let i = 0; i < sampleCount; i++) {
        samples.push({
          id: `${well.ID}-sample-${i + 1}`,
          fluidSampleID: `SMP-${well.name}-${String(i + 1).padStart(3, '0')}`,
          sampleType: sampleTypes[Math.floor(Math.random() * sampleTypes.length)],
          qaqcStatus: qaqcStatuses[Math.floor(Math.random() * qaqcStatuses.length)],
          wellName: well.name,
          qaqcNotes: ''
        });
      }
      
      return samples;
    },
    generateMockSourceFiles() {
      // Generate mock source files data for demonstration
      const fileTypes = ['Excel', 'CSV', 'PDF', 'Text', 'Database'];
      const qaqcStatuses = ['Pending Review', 'Under Review', 'Approved', 'Rejected', 'Needs Correction'];
      
      const sourceFiles = [];
      
      for (let i = 1; i <= 15; i++) {
        sourceFiles.push({
          id: `file-${i}`,
          name: `Source_File_${String(i).padStart(3, '0')}.${fileTypes[Math.floor(Math.random() * fileTypes.length)].toLowerCase()}`,
          type: fileTypes[Math.floor(Math.random() * fileTypes.length)],
          qaqcStatus: qaqcStatuses[Math.floor(Math.random() * qaqcStatuses.length)],
          uploadDate: new Date(Date.now() - Math.random() * 30 * 24 * 60 * 60 * 1000),
          qaqcNotes: ''
        });
      }
      
      this.sourceFiles = sourceFiles;
    },
    getRandomQAQCStatus() {
      const statuses = ['Pending', 'Under Review', 'Approved', 'Rejected', 'Needs Correction'];
      return statuses[Math.floor(Math.random() * statuses.length)];
    },
    getSampleCountColor(count) {
      if (count === 0) return 'grey';
      if (count <= 5) return 'success';
      if (count <= 15) return 'warning';
      return 'error';
    },
    getQAQCStatusColor(status) {
      const statusColors = {
        'Pending': 'grey',
        'Pending Review': 'grey',
        'Under Review': 'warning',
        'Approved': 'success',
        'Rejected': 'error',
        'Needs Correction': 'error',
        'Completed': 'success'
      };
      return statusColors[status] || 'grey';
    },
    getFileTypeColor(type) {
      const typeColors = {
        'Excel': 'success',
        'CSV': 'info',
        'PDF': 'error',
        'Text': 'warning',
        'Database': 'primary'
      };
      return typeColors[type] || 'grey';
    },
    formatDate(date) {
      if (!date) return 'N/A';
      return new Date(date).toLocaleDateString();
    },
    navigateToDetailView(type, wellName = null) {
      // Navigate to QA/QC detail view
      const query = { type: type };
      if (wellName) {
        query.well = wellName;
      }
      console.log('Navigating to DetailView with:', { type, wellName, query }); // Debug log
      this.$router.push({
        name: 'QAQCDetailView',
        query: query,
      });
    },
    navigateToQAQCSampleDetail(well, sampleId) {
      // Navigate to detailed QA/QC sample view
      this.$router.push({
        name: 'QAQCSampleDetail',
        params: { 
          well: well.name,
          sampleId: sampleId 
        },
      });
    },
    openQAQCModal(sample) {
      this.selectedSample = { ...sample };
      this.showQAQCModal = true;
    },
    saveQAQCReview() {
      // Here you would typically save the QA/QC review to your backend
      console.log('Saving QA/QC review:', this.selectedSample);
      
      // Show success message
      this.$toast.success('QA/QC review saved successfully');
      
      // Close modal
      this.showQAQCModal = false;
      
      // Update the well data
      this.updateSampleQAQCStatus();
    },
    openSourceFileQAQCModal(file) {
      this.selectedSourceFile = { ...file };
      this.showSourceFileQAQCModal = true;
    },
    saveSourceFileQAQCReview() {
      // Here you would typically save the source file QA/QC review to your backend
      console.log('Saving source file QA/QC review:', this.selectedSourceFile);
      
      // Show success message
      this.$toast.success('Source file QA/QC review saved successfully');
      
      // Close modal
      this.showSourceFileQAQCModal = false;
      
      // Update the source file data
      this.updateSourceFileQAQCStatus();
    },
    updateSourceFileQAQCStatus() {
      // Update the source file in the sourceFiles data
      this.sourceFiles.forEach(file => {
        if (file.id === this.selectedSourceFile.id) {
          file.qaqcStatus = this.selectedSourceFile.qaqcStatus;
          file.qaqcNotes = this.selectedSourceFile.qaqcNotes;
        }
      });
    },
    updateSampleQAQCStatus() {
      // Update the sample in the wells data
      this.wells.forEach(well => {
        well.data.forEach(sample => {
          if (sample.id === this.selectedSample.id) {
            sample.qaqcStatus = this.selectedSample.qaqcStatus;
            sample.qaqcNotes = this.selectedSample.qaqcNotes;
          }
        });
      });
    }
  },
  mounted() {
    this.fetchData();
  },
};
</script>

<style scoped>
.qa-tabs {
  margin-top: 16px;
  margin-bottom: 16px;
}

.qa-tabs .v-tab {
  font-size: 16px;
  font-weight: 500;
  text-transform: none;
  min-height: 30px;
}

.qa-tabs .v-tab--selected {
  font-weight: 600;
}

.file-info {
  display: flex;
  align-items: center;
}

.file-name {
  font-weight: 500;
}

.cursor-pointer {
  cursor: pointer;
}

.clickable-cell:hover {
  background-color: #062D42;
  color: white;
}

.well-top-wrap {
  padding: 0px 16px;
}

/* Search Header Styling */
.search-header {
  background-color: #f8f9fa;
  border-bottom: 1px solid #e0e0e0;
}

.search-header th {
  padding: 8px 12px;
  vertical-align: middle;
}

.search-field {
  max-width: 200px;
}

.search-field .v-field__input {
  padding: 8px 12px;
  font-size: 14px;
}

.search-field .v-field__outline {
  border-color: #d0d0d0;
}

.search-field .v-field--focused .v-field__outline {
  border-color: #1976d2;
}

/* Header Content Layout - Data Management Style */
.sort-icon-title {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  justify-content: space-between;
}

.sort-icons {
  display: flex;
  align-items: center;
  gap: 5px;
}

.img-div {
  display: flex;
  align-items: center;
}

.img-div img {
  width: 16px;
  height: 16px;
  cursor: pointer;
  opacity: 0.7;
  transition: opacity 0.2s ease;
}

.img-div img:hover {
  opacity: 1;
}

.search-icon {
  display: flex;
  align-items: center;
  cursor: pointer;
  opacity: 0.7;
  transition: opacity 0.2s ease;
}

.search-icon:hover {
  opacity: 1;
}

.close-icon {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.search-dropdown-menu {
  position: relative;
}

/* Ensure header content is on same line */
.search-dropdown-menu .sort-icon-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

/* Search Dropdown Styling */
.search-table {
  margin-bottom: 8px;
}

.data-list-content {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
}

.custom-checkbox {
  width: 16px;
  height: 16px;
  cursor: pointer;
}

.option-text {
  font-size: 13px;
  color: #333;
  flex: 1;
}

.list-items:hover {
  background-color: #f5f5f5;
}
</style>
